
import { defineComponent } from 'vue';
import { translate } from 'CoreHome';
import InsightOffcanvas from './InsightOffcanvas.vue';
import IconAi from '../Icon/IconAi.vue';

const __default__ = defineComponent({
  components: {
    IconAi,
    InsightOffcanvas,
  },
  props: {
    widgetParams: {
      type: Object,
      required: true,
    },
    aiName: {
      type: String,
      required: true,
    },
    aiLabel: {
      type: String,
      required: true,
    },
    aiColor: {
      type: String,
      default: '#3450a3',
    },
    apiMethod: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      displayOffcanvas: false,
    };
  },
  computed: {
    buttonTitle(): string {
      return translate('ChatGPT_AskQuestion', this.aiLabel);
    },
  },
  methods: {
    onClick() {
      this.displayOffcanvas = !this.displayOffcanvas;
      (this.$refs.offCanvas as InstanceType<typeof InsightOffcanvas>).onSubmit();
    },
    onClose() {
      this.displayOffcanvas = false;
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "02f7d71e": (_ctx.aiColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__